/** Opaque signup invite links (?i= signed token from API). Legacy ?c=&r= still parsed for old links. */

export const SIGNUP_INVITE_ROLES = [
  { role: "Student", code: "s", labelKey: "club_invite_role_student" },
  { role: "Parent", code: "p", labelKey: "club_invite_role_parent" },
  { role: "student&Parent", code: "b", labelKey: "club_invite_role_both" },
];

const CODE_TO_ROLE = Object.fromEntries(SIGNUP_INVITE_ROLES.map(({ role, code }) => [code, role]));

const ROLE_ALIASES = {
  s: "Student",
  student: "Student",
  p: "Parent",
  parent: "Parent",
  b: "student&Parent",
  both: "student&Parent",
  "student&parent": "student&Parent",
  "student&Parent": "student&Parent",
};

/**
 * @param {{ origin?: string; token: string }} opts
 * @returns {string}
 */
export function buildSignupInviteLink({ origin, token }) {
  if (!token) return "";
  const base = (origin || (typeof window !== "undefined" ? window.location.origin : "")).replace(/\/$/, "");
  return `${base}/signup?i=${encodeURIComponent(token)}`;
}

/**
 * @param {string} search
 * @returns {string|null}
 */
export function getSignupInviteTokenFromSearch(search) {
  const params = new URLSearchParams(search.startsWith("?") ? search.slice(1) : search);
  const raw = params.get("i") ?? params.get("invite");
  if (raw == null || String(raw).trim() === "") return null;
  return String(raw).trim();
}

/**
 * Legacy plain query params (?c=clubId&r=s|p|b).
 * @param {string} search
 * @returns {{ clubID: string|null; role: string|null }}
 */
export function parseLegacySignupInviteFromSearch(search) {
  const params = new URLSearchParams(search.startsWith("?") ? search.slice(1) : search);
  if (getSignupInviteTokenFromSearch(search)) {
    return { clubID: null, role: null };
  }
  const clubRaw = params.get("c") ?? params.get("club") ?? params.get("clubID");
  const clubID = clubRaw != null && String(clubRaw).trim() !== "" ? String(clubRaw).trim() : null;

  const roleRaw = params.get("r") ?? params.get("role");
  let role = null;
  if (roleRaw != null && String(roleRaw).trim() !== "") {
    const key = String(roleRaw).trim();
    const normalized = key.toLowerCase();
    role =
      CODE_TO_ROLE[normalized] ??
      ROLE_ALIASES[normalized] ??
      (["Student", "Parent", "student&Parent"].includes(key) ? key : null);
  }

  return { clubID, role };
}

/** @deprecated use getSignupInviteTokenFromSearch + resolvePublicSignupInvite */
export function parseSignupInviteFromSearch(search) {
  return parseLegacySignupInviteFromSearch(search);
}
